/**
 * @React
 */
import React, {
    FC,
    useState,
} from "react";

import { useHistory } from "react-router-dom";
/**
 * @MUI
 */
import {
    Box,
    Button,
    Divider,
} from "@mui/material";
/**
 * @Components
 */
import Loader from "../../Loader";
import CardFieldSet from "../../CustomComponents/CardFieldSet";
import { MonitoringLogsDetailsCgs } from "../../detailedApplication/MonitoringApplication";
import { IMonitoringCgsFields } from "../../../types/monitoringCgsFields";
import CustomField from "../../CustomComponents/CustomFields/input";
/**
 * @ReactHookForm
 */
import {
    Controller,
    FormProvider,
    SubmitErrorHandler,
    useFieldArray,
    useForm,
} from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
/**
 * @Validation
 */
import { monitoringCgsDeadlineApprove } from "./validation";
/**
 * @Hooks
 */
import { useMonitoringCgsApencyAproveHook } from "../../../hooks/useMonitoringCgsApencyAproveHook";
/**
 * @Utilities
 */
import {
    getFirstErrorMessage,
} from "../../../utilities/Fields/monitoringFields/utils";
import DetailePageStyles from "../../../utilities/DetailePageStayles";
import { monitoringValueMappers } from "../../../utilities/Fields/CgsMonitoringFields/monitoringDeps";
/**
 * @Types
 */
import { ApproveData } from "../../../types";
interface MonitoringDeadlineApproveFormProps {
    data: ApproveData;
    load: boolean;
    url: string;
    opts?: any;
    onClose?: () => void; // useSate from props
    callback?: (data: any) => void; // useSate from props
}
const MonitoringDeadlineApproveForm: FC<MonitoringDeadlineApproveFormProps> = ({
    data,
    load,
    url,
    opts,
    onClose,
    callback,
}) => {
    const history = useHistory();
    const classes = DetailePageStyles();

    const [submitReload, setSubmitReload] = useState<boolean>(false);
    const methods = useForm<ApproveData>({
        defaultValues: data as ApproveData,
        resolver: yupResolver(monitoringCgsDeadlineApprove) as any,
        mode: "onBlur",
    });
    const {
        setValue,
        control,
        handleSubmit,
        watch,
    } = methods as any;

    const watchedValues = watch();
    useMonitoringCgsApencyAproveHook(watchedValues, setValue, data);

    const onError: SubmitErrorHandler<ApproveData> = (errors) => {
        const message = getFirstErrorMessage(errors)
        alert(message);
    };

    const onSubmit = (data: ApproveData) => {
        callback && callback(data);
        onClose && onClose();
    };
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    width: `100%`,
                }}
            >
                <FormProvider {...(methods as any)}>
                    {
                        <form
                            onSubmit={
                                handleSubmit(onSubmit, onError)
                            }
                            noValidate
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    width: `100%`,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        minHeight: "80px",
                                    }}
                                >
                                    <label style={{
                                        fontSize: "11px",
                                        padding: "8px",
                                        color: "rgb(0, 0, 0, 0.8)",
                                    }}>
                                        {'დარღვევის აღმოსაფხვრელად მიცემული გონივრული ვადა (თვე/დღე)'}
                                    </label>

                                    <CustomField
                                        name={'unfulfilled_used_amount_month_day'}
                                        label={''}
                                        type={'day'}
                                        control={control}
                                    // disabled={false}
                                    // errors={''}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        // minHeight: "50px",
                                    }}>
                                    <label style={{
                                        fontSize: "11px",
                                        padding: "8px",
                                        color: "rgb(0, 0, 0, 0.8)",
                                    }}>
                                        {'განმეორებითი მონიტორინგის ჩატარების თარიღი'}
                                    </label>
                                    <Controller
                                        key={'21'}
                                        name={'monitoring_new_deadline'}
                                        control={control}
                                        render={({ field }) => (
                                            <output
                                                style={{
                                                    fontSize: "11px",
                                                    padding: "8px",
                                                    height: "20px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                {monitoringValueMappers['monitoring_new_deadline'](field.value)}
                                            </output>
                                        )}
                                    />
                                </Box>
                                <Divider />
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        // minHeight: "50px",
                                    }}
                                >
                                    <CustomField
                                        name={'monitoring_deadline_comment'}
                                        label={'დარღვევის აღმოსაფხვრელად მიცემული ერთ წელზე მეტი ვადის შესახებ დეპ. უფროსის კომენტარი'}
                                        type={'textarea'}
                                        control={control}
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "20px",
                                        width: `100%`,
                                    }}
                                >
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{
                                            width: "50%",
                                            fontSize: "12px",
                                        }}
                                    >
                                        გაგზავნა
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="contained"
                                        sx={{
                                            width: "50%",
                                            fontSize: "12px",
                                        }}
                                        onClick={() => onClose && onClose()}
                                    >
                                        გაუქმება
                                    </Button>
                                </Box>
                            </Box>
                        </form>
                    }
                </FormProvider>
            </Box >
        </>

    );
};

export default MonitoringDeadlineApproveForm;
